import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const ToppersXII = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Toppers XII"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Toppers XII" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-12">
                <div class="section-title mb-4 pr-lg-5 px-4 px-lg-2">
                  <h2 class="title"><span class="text-primary">Toppers XII</span></h2>              
                  <div className="curved-line mx-auto mt-3"></div>
                </div>            
              </div>          
            </div>
            <div class="row align-items-center">
              <div class="col-md-8 mx-auto">
                  <div className='smart-classroom'>
                      <div className="image-gallery">           
                          <div className="image-item">
                            <img src="/images/inter.png" className='w-100' alt='' />
                          </div>           
                      </div>
                  </div>
              </div>
             
           </div>
          </div>
    </section>
    </>
  )
}

export default ToppersXII
